<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1u8Cfx/tc-custom/9781771088275.jpg?1728851674332" alt="This image is the cover for the book Saltwater Chronicles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Saltwater Chronicles
      </h1>
      <p class="bookDescription body article font2">
        <b>The award–winning author celebrates the everyday disasters and discoveries that shape a life in this memoir of love, loss, and adventure in Nova Scotia.</b><br/>  <br/> If Lesley Choyce was not a surfer, he would not have dropped out of graduate school in Manhattan in 1978 and moved to Nova Scotia—a decision that made all the difference. In <i>Saltwater Chronicles</i>, he reflects on the ambitious, idealistic, and brash young man he once was, while the older man ahead of him beckons him forward with a mischievous grin.<br/>  <br/> In between, Choyce adapts to the crisis of becoming a respectable citizen. He experiences the death of his father and of his family dog. He helps guide his wife through cancer as they ride the North Atlantic waves and record a most human range of sorrows and joys.<br/>  <br/> In this, his one-hundredth book, Lesley Choyce takes readers along as he writes about nearly everything under the sun from his home by the sea on the North Atlantic coast of Canada—all of it most ordinary and extraordinary at the same time.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lesley Choyce
      </h2>
      
      <p class="authorDescription body article">Lesley Choyce runs Pottersfield Press and teaches at Dalhousie University. He has won The Dartmouth Book Award, The Atlantic Poetry Prize, and The Ann Connor Brimer Award and has been shortlisted for the Governor General's Award for his writing.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Nimbus Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cbb5537e